import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography, Box } from '@material-ui/core';
import Chart from 'react-apexcharts';
import { COLORS } from '../../constants/colors';
import { useDashboardStyles } from '../../styles/DashboardInformeStyle';

export default function BarChart({ categorias, serieActual, serieAnterior, mesActual, mesAnterior }) {
  const classes = useDashboardStyles();

  const nulo = (v) => v == null || v === 0;

  const indicesValidos = useMemo(() => {
    const cats = categorias || [];
    const a = serieActual || [];
    const b = serieAnterior || [];
    return cats.map((_, i) => i).filter((i) => !nulo(a[i]) || !nulo(b[i]));
  }, [categorias, serieActual, serieAnterior]);

  const categoriasFiltradas = useMemo(
    () => indicesValidos.map((i) => (categorias || [])[i]),
    [indicesValidos, categorias]
  );

  const series = useMemo(() => [
    { name: mesAnterior || 'Mes anterior', data: indicesValidos.map((i) => (serieAnterior || [])[i] ?? 0) },
    { name: mesActual || 'Mes actual', data: indicesValidos.map((i) => (serieActual || [])[i] ?? 0) },
  ], [mesActual, mesAnterior, serieActual, serieAnterior, indicesValidos]);

  const sinDatos = indicesValidos.length === 0;

  const chartOptions = useMemo(() => ({
    chart: { type: 'bar', toolbar: { show: false } },
    plotOptions: {
      bar: { columnWidth: '60%', borderRadius: 3 },
    },
    dataLabels: {
      enabled: true,
      style: { fontSize: '9px', colors: [COLORS.textPrimary] },
      offsetY: -4,
    },
    xaxis: {
      categories: categoriasFiltradas,
      labels: {
        rotate: -45,
        style: { fontSize: '10px' },
      },
    },
    yaxis: {
      labels: { style: { fontSize: '11px' } },
    },
    colors: [COLORS.primary, COLORS.error],
    legend: { position: 'top', fontSize: '12px' },
    noData: {
      text: 'Sin datos disponibles',
      style: { fontSize: '14px', color: COLORS.textSecondary },
    },
  }), [categoriasFiltradas]);

  return (
    <Paper className={classes.chartCard}>
      <Typography className={classes.chartTitle} color="primary">
        Historial de mediciones
      </Typography>
      <Box style={{ marginTop: 8 }}>
        {sinDatos ? (
          <Typography style={{ color: '#aaa', textAlign: 'center', marginTop: 40 }}>
            Sin datos disponibles
          </Typography>
        ) : (
          <Chart options={chartOptions} series={series} type="bar" height={280} />
        )}
      </Box>
    </Paper>
  );
}

BarChart.propTypes = {
  categorias: PropTypes.arrayOf(PropTypes.string),
  serieActual: PropTypes.arrayOf(PropTypes.number),
  serieAnterior: PropTypes.arrayOf(PropTypes.number),
  mesActual: PropTypes.string,
  mesAnterior: PropTypes.string,
};
